import { createFileRoute } from "@tanstack/react-router";

import Statistics from "../pages/Statistics";
import { useAppShell } from "../layouts/AppShellContext";
import { RequireAuth } from "../utils/RequireAuth";
import { parseStatisticsSearch } from "../pages/Statistics/utils/statisticsSearchParams";

export const Route = createFileRoute("/_shell/statistics")({
  validateSearch: (search) => parseStatisticsSearch(search as Record<string, unknown>),
  component: StatisticsRoute,
});

function StatisticsRoute() {
  const { isSidebarOpen } = useAppShell();

  return (
    <RequireAuth page="statistics">
      <Statistics isSidebarOpen={isSidebarOpen} />
    </RequireAuth>
  );
}
